import { Component, Emit, Model, Vue } from 'vue-property-decorator';
import GoModal from '@/core/go-modal/go-modal.vue';
import { REPORT_STYLES, REPORT_TYPES } from '@/constants';

@Component({
  computed: {
    REPORT_STYLES() {
      return REPORT_STYLES;
    },
    REPORT_TYPES() {
      return REPORT_TYPES;
    },
  },
  components: {
    'go-modal': GoModal,
  },
})
export default class GenerateReportModal extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;

  formData = {
    reportType: REPORT_TYPES.DAILY,
    reportStyle: {
      DAILY: REPORT_STYLES.BUSINESS,
      PRODUCT_REVIEW: REPORT_STYLES.BUSINESS,
      INVESTMENT: REPORT_STYLES.BUSINESS,
      INDEPTH_DAILY: REPORT_STYLES.BUSINESS,
    },
  };

  @Emit('modal:close') close() {}

  @Emit('modal:ok') ok(payload: any) {}

  mounted() {
    console.log('Modal Component mounted.');
  }

  selectType(type: any) {
    this.formData.reportType = type;
  }

  save() {
    const payload = {
      reportType: this.formData.reportType,
      reportStyle: this.formData.reportStyle[this.formData.reportType],
    };
    this.ok(payload);
  }
}
